import type { Router } from 'vue-router'

import { onUnauthorized } from '@/api/http'

import { ROUTE_LOGIN } from '../router/names'
import { useAuthStore } from '../stores/auth'

import { endSession } from './index'

/**
 * What a 401 does (wp/shell §4.12, P1, OPEN-1 default (a)): any 401 ends the session and goes to `/login` — and the
 * calling screen's promise **rejects** (http.ts), so its error path runs (legacy left it pending). On a public page
 * (Apply, public invoice/quote, the auth pages) a dead session is not a reason to leave: the page handles the refusal
 * itself (wp/company NEW-20, wp/quotes §1.4).
 */
export function installUnauthorizedHandler(router: Router): void {
  onUnauthorized(() => {
    if (!useAuthStore().session) return
    if (router.currentRoute.value.meta.public) return
    endSession()
    void router.replace({ name: ROUTE_LOGIN })
  })
}
